import {
  a1 as Unit_getInstance,
  ga as VOID,
  y9 as ensureNotNull,
  m6 as objectMeta,
  o6 as setMetadataFor,
  h2 as emptyList,
  s9 as THROW_CCE,
  e6 as isInterface,
  g6 as isObject,
  n6 as protoOf,
  p5 as classMeta,
  l1 as List,
  k2 as filterNotNull,
  s2 as joinToString,
  g4 as toMutableList,
  c3 as listOf,
  ea as toString,
  k9 as IllegalStateException,
  r6 as toString_0,
  j4 as toSet,
  i2 as emptyMap,
  e1 as ArrayList,
  a2 as collectionSizeOrDefault,
  x5 as getStringHashCode,
  y5 as hashCode,
  s5 as equals,
} from './kotlin-kotlin-stdlib.mjs';
import {
  a as LanguageProcessorPhase_ALL_getInstance,
  g2 as IssueHolder,
  h2 as ProcessResultDefault,
  h as Agl_getInstance,
  b as LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance,
  i2 as SemanticAnalysisResultDefault,
  d as analyse,
  l3 as SemanticAnalyser,
  i as ListSeparatedArrayList,
  h3 as SyntaxAnalyserByMethodRegistrationAbstract,
  e as configure,
} from './net.akehurst.language-agl-processor.mjs';
import {
  o as TypeModel,
  g1 as TypeModelSimple,
  i1 as TypeNamespaceSimple,
  e1 as TypeInstanceSimple,
  e as PropertyCharacteristic_REFERENCE_getInstance,
  c as PropertyCharacteristic_IDENTITY_getInstance,
  d as PropertyCharacteristic_MEMBER_getInstance,
  a as PropertyCharacteristic_COMPOSITE_getInstance,
  v as PrimitiveTypeSimple,
  u as EnumTypeSimple,
  s as CollectionTypeSimple,
  t as DataTypeSimple,
} from './net.akehurst.language-type-model.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Komposite {
  constructor() {
    Komposite_instance = this;
    this.v4h_1 = null;
  }
  w4h() {
    if (null == this.v4h_1) {
      var grammarStr = this.x4h();
      var tmp = Agl_getInstance();
      var tmp_0 = Agl_getInstance();
      var res = tmp.processorFromString(grammarStr, tmp_0.configuration(VOID, Komposite$processor$lambda));
      this.v4h_1 = res.processor;
    }
    return ensureNotNull(this.v4h_1);
  }
  x4h() {
    return "namespace net.akehurst.kotlin.komposite\n\ngrammar Composite {\n    skip WHITE_SPACE = \"\\s+\" ;\n    skip COMMENT = MULTI_LINE_COMMENT | SINGLE_LINE_COMMENT ;\n         MULTI_LINE_COMMENT = \"[/][*](?:.|\\n)*?[*][/]\" ;\n         SINGLE_LINE_COMMENT = \"//[^\\n\\r]*\" ;\n\n    model = namespace* ;\n    namespace = 'namespace' qualifiedName '{' import* declaration* '}' ;\n    qualifiedName = [ NAME / '.']+ ;\n    import = 'import' qualifiedName ;\n    declaration = primitive | enum | collection | datatype ;\n    primitive = 'primitive' NAME ;\n    enum = 'enum' NAME ;\n    collection = 'collection' NAME '<' typeParameterList '>' ;\n    typeParameterList = [ NAME / ',']+ ;\n    datatype = 'datatype' NAME supertypes? '{' property* '}' ;\n    supertypes = ':' [ typeReference / ',']+ ;\n    property = characteristic NAME ':' typeReference ;\n    typeReference = qualifiedName typeArgumentList? '?'?;\n    typeArgumentList = '<' [ typeReference / ',']+ '>' ;\n    characteristic\n       = 'reference-val'    // reference, constructor argument\n       | 'reference-var'    // reference mutable property\n       | 'composite-val'    // composite, constructor argument\n       | 'composite-var'    // composite mutable property\n       | 'dis'    // disregard / ignore\n       ;\n\n    leaf NAME = \"[a-zA-Z_][a-zA-Z0-9_]*\" ;\n    leaf POSITIVE_INTEGER = \"[0-9]+\" ;\n}\n";
  }
  x4g(datatypeModel) {
    return this.w4h().process(datatypeModel);
  }
}
class KompositeSemanticAnalyser {
  clear() {
  }
  configure(configurationContext, configuration) {
    return emptyList();
  }
  y4h(asm, locationMap, context, options) {
    return new SemanticAnalysisResultDefault(new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance()));
  }
  g1b(asm, locationMap, context, options) {
    var tmp = isInterface(asm, TypeModel) ? asm : THROW_CCE();
    return this.y4h(tmp, locationMap, (context == null ? true : isObject(context)) ? context : THROW_CCE(), options);
  }
}
class KompositeSyntaxAnalyser2 extends SyntaxAnalyserByMethodRegistrationAbstract {
  constructor() {
    super();
    this.h4i_1 = emptyMap();
  }
  registerHandlers() {
    super.register(KompositeSyntaxAnalyser2$model$ref(this));
    super.register(KompositeSyntaxAnalyser2$namespace$ref(this));
    super.register(KompositeSyntaxAnalyser2$qualifiedName$ref(this));
    super.register(KompositeSyntaxAnalyser2$import$ref(this));
    super.register(KompositeSyntaxAnalyser2$declaration$ref(this));
    super.register(KompositeSyntaxAnalyser2$primitive$ref(this));
    super.register(KompositeSyntaxAnalyser2$enum$ref(this));
    super.register(KompositeSyntaxAnalyser2$collection$ref(this));
    super.register(KompositeSyntaxAnalyser2$datatype$ref(this));
    super.register(KompositeSyntaxAnalyser2$supertypes$ref(this));
    super.register(KompositeSyntaxAnalyser2$property$ref(this));
    super.register(KompositeSyntaxAnalyser2$characteristic$ref(this));
    super.register(KompositeSyntaxAnalyser2$typeReference$ref(this));
    super.register(KompositeSyntaxAnalyser2$typeArgumentList$ref(this));
  }
  o1b() {
    return this.h4i_1;
  }
  clear() {
    super.clear();
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
}
class TypeRefInfo {
  constructor(name, args, isNullable) {
    this.z4h_1 = name;
    this.a4i_1 = args;
    this.b4i_1 = isNullable;
  }
  c4i(namespace) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.a4i_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.kotlin.komposite.processor.TypeRefInfo.toTypeInstance.<anonymous>' call
      tmp$ret$0 = item.c4i(namespace);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var targs = tmp$ret$2;
    return namespace.createTypeInstance(this.z4h_1, targs, this.b4i_1);
  }
  toString() {
    return 'TypeRefInfo(name=' + this.z4h_1 + ', args=' + this.a4i_1 + ', isNullable=' + this.b4i_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.z4h_1);
    result = imul(result, 31) + hashCode(this.a4i_1) | 0;
    result = imul(result, 31) + (this.b4i_1 | 0) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TypeRefInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TypeRefInfo ? other : THROW_CCE();
    if (!(this.z4h_1 === tmp0_other_with_cast.z4h_1))
      return false;
    if (!equals(this.a4i_1, tmp0_other_with_cast.a4i_1))
      return false;
    if (!(this.b4i_1 === tmp0_other_with_cast.b4i_1))
      return false;
    return true;
  }
}
//endregion
function Komposite$processor$lambda($this$configuration) {
  $this$configuration.defaultGoalRuleName('model');
  $this$configuration.syntaxAnalyserResolver(Komposite$processor$lambda$lambda);
  $this$configuration.semanticAnalyserResolver(Komposite$processor$lambda$lambda_0);
  return Unit_getInstance();
}
function Komposite$processor$lambda$lambda(it) {
  return new ProcessResultDefault(new KompositeSyntaxAnalyser2(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function Komposite$processor$lambda$lambda_0(it) {
  return new ProcessResultDefault(new KompositeSemanticAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
var Komposite_instance;
function Komposite_getInstance() {
  if (Komposite_instance === VOID)
    new Komposite();
  return Komposite_instance;
}
function model($this, nodeInfo, children, sentence) {
  var result = new TypeModelSimple('aTypeModel');
  var namespaces = filterNotNull(isInterface(children, List) ? children : THROW_CCE());
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = namespaces.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.kotlin.komposite.processor.KompositeSyntaxAnalyser2.model.<anonymous>' call
    result.addNamespace(element);
  }
  return result;
}
function namespace($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var qualifiedName = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var imports = filterNotNull((!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE());
  var tmp_1 = children.p(4);
  var declaration = filterNotNull((!(tmp_1 == null) ? isInterface(tmp_1, List) : false) ? tmp_1 : THROW_CCE());
  var qn = joinToString(qualifiedName, '.');
  var ns = new TypeNamespaceSimple(qn, toMutableList(imports));
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = declaration.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.kotlin.komposite.processor.KompositeSyntaxAnalyser2.namespace.<anonymous>' call
    var dec = element(ns);
    ns.addDeclaration(dec);
  }
  return ns;
}
function qualifiedName($this, nodeInfo, children, sentence) {
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  return ListSeparatedArrayList.u1f(children).a11();
}
function import_0($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var qualifiedName = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  return joinToString(qualifiedName, '.');
}
function declaration($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE();
}
function primitive($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var result = KompositeSyntaxAnalyser2$primitive$lambda(name);
  return result;
}
function enum_0($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var result = KompositeSyntaxAnalyser2$enum$lambda(name);
  return result;
}
function collection($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var params = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
  var result = KompositeSyntaxAnalyser2$collection$lambda(name, params);
  return result;
}
function datatype($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(2);
  var tmp0_elvis_lhs = (tmp_0 == null ? true : isInterface(tmp_0, List)) ? tmp_0 : THROW_CCE();
  var supertypes = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  var tmp_1 = children.p(4);
  var property = filterNotNull((!(tmp_1 == null) ? isInterface(tmp_1, List) : false) ? tmp_1 : THROW_CCE());
  var result = KompositeSyntaxAnalyser2$datatype$lambda(name, supertypes, property, $this);
  return result;
}
function setResolvers($this, ti, dt) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = ti.lq_1.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.kotlin.komposite.processor.KompositeSyntaxAnalyser2.setResolvers.<anonymous>' call
    setResolvers($this, element instanceof TypeInstanceSimple ? element : THROW_CCE(), dt);
  }
}
function supertypes($this, nodeInfo, children, sentence) {
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var tmp = children.p(1);
  var tmp0_toSeparatedList = filterNotNull((!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE());
  return ListSeparatedArrayList.u1f(tmp0_toSeparatedList).a11();
}
function property($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  var characteristics = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(1);
  var name = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(3);
  var typeRef = tmp_1 instanceof TypeRefInfo ? tmp_1 : THROW_CCE();
  var result = KompositeSyntaxAnalyser2$property$lambda(typeRef, name, characteristics);
  return result;
}
function characteristic($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  var tmp_0;
  switch ((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE()) {
    case 'reference-val':
      tmp_0 = listOf([PropertyCharacteristic_REFERENCE_getInstance(), PropertyCharacteristic_IDENTITY_getInstance()]);
      break;
    case 'reference-var':
      tmp_0 = listOf([PropertyCharacteristic_REFERENCE_getInstance(), PropertyCharacteristic_MEMBER_getInstance()]);
      break;
    case 'composite-val':
      tmp_0 = listOf([PropertyCharacteristic_COMPOSITE_getInstance(), PropertyCharacteristic_IDENTITY_getInstance()]);
      break;
    case 'composite-var':
      tmp_0 = listOf([PropertyCharacteristic_COMPOSITE_getInstance(), PropertyCharacteristic_MEMBER_getInstance()]);
      break;
    case 'dis':
      tmp_0 = emptyList();
      break;
    default:
      var tmp0_error = "Value not allowed '" + toString(children.p(0)) + "'";
      throw IllegalStateException.y1(toString_0(tmp0_error));
  }
  return tmp_0;
}
function typeReference($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  var qualifiedName = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(1);
  var tmp0_elvis_lhs = (tmp_0 == null ? true : isInterface(tmp_0, List)) ? tmp_0 : THROW_CCE();
  var typeArgumentList = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  var qname = joinToString(qualifiedName, '.');
  var tmp_1 = children.p(2);
  var isNullable = !(((tmp_1 == null ? true : typeof tmp_1 === 'string') ? tmp_1 : THROW_CCE()) == null);
  var tr = new TypeRefInfo(qname, typeArgumentList, isNullable);
  return tr;
}
function typeArgumentList($this, nodeInfo, children, sentence) {
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var tmp = children.p(1);
  var tmp0_toSeparatedList = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var list = ListSeparatedArrayList.u1f(tmp0_toSeparatedList).a11();
  return list;
}
function KompositeSyntaxAnalyser2$model$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return model($boundThis, p0, p1, p2);
  };
  l.callableName = 'model';
  return l;
}
function KompositeSyntaxAnalyser2$namespace$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return namespace($boundThis, p0, p1, p2);
  };
  l.callableName = 'namespace';
  return l;
}
function KompositeSyntaxAnalyser2$qualifiedName$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return qualifiedName($boundThis, p0, p1, p2);
  };
  l.callableName = 'qualifiedName';
  return l;
}
function KompositeSyntaxAnalyser2$import$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return import_0($boundThis, p0, p1, p2);
  };
  l.callableName = 'import';
  return l;
}
function KompositeSyntaxAnalyser2$declaration$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return declaration($boundThis, p0, p1, p2);
  };
  l.callableName = 'declaration';
  return l;
}
function KompositeSyntaxAnalyser2$primitive$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return primitive($boundThis, p0, p1, p2);
  };
  l.callableName = 'primitive';
  return l;
}
function KompositeSyntaxAnalyser2$enum$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return enum_0($boundThis, p0, p1, p2);
  };
  l.callableName = 'enum';
  return l;
}
function KompositeSyntaxAnalyser2$collection$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return collection($boundThis, p0, p1, p2);
  };
  l.callableName = 'collection';
  return l;
}
function KompositeSyntaxAnalyser2$datatype$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return datatype($boundThis, p0, p1, p2);
  };
  l.callableName = 'datatype';
  return l;
}
function KompositeSyntaxAnalyser2$supertypes$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return supertypes($boundThis, p0, p1, p2);
  };
  l.callableName = 'supertypes';
  return l;
}
function KompositeSyntaxAnalyser2$property$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return property($boundThis, p0, p1, p2);
  };
  l.callableName = 'property';
  return l;
}
function KompositeSyntaxAnalyser2$characteristic$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return characteristic($boundThis, p0, p1, p2);
  };
  l.callableName = 'characteristic';
  return l;
}
function KompositeSyntaxAnalyser2$typeReference$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return typeReference($boundThis, p0, p1, p2);
  };
  l.callableName = 'typeReference';
  return l;
}
function KompositeSyntaxAnalyser2$typeArgumentList$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return typeArgumentList($boundThis, p0, p1, p2);
  };
  l.callableName = 'typeArgumentList';
  return l;
}
function KompositeSyntaxAnalyser2$primitive$lambda($name) {
  return function (namespace) {
    return new PrimitiveTypeSimple(namespace, $name);
  };
}
function KompositeSyntaxAnalyser2$enum$lambda($name) {
  return function (namespace) {
    return new EnumTypeSimple(namespace, $name, emptyList());
  };
}
function KompositeSyntaxAnalyser2$collection$lambda($name, $params) {
  return function (namespace) {
    return new CollectionTypeSimple(namespace, $name, $params);
  };
}
function KompositeSyntaxAnalyser2$datatype$lambda($name, $supertypes, $property, this$0) {
  return function (ns) {
    var dt = new DataTypeSimple(ns, $name);
    var tmp0_iterator = $supertypes.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.kotlin.komposite.processor.KompositeSyntaxAnalyser2.datatype.<anonymous>.<anonymous>' call
      dt.addSupertype(element.z4h_1);
    }
    var tmp0_iterator_0 = $property.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.kotlin.komposite.processor.KompositeSyntaxAnalyser2.datatype.<anonymous>.<anonymous>' call
      var p = element_0(dt);
      var tmp = p.typeInstance;
      setResolvers(this$0, tmp instanceof TypeInstanceSimple ? tmp : THROW_CCE(), dt);
    }
    return dt;
  };
}
function KompositeSyntaxAnalyser2$property$lambda($typeRef, $name, $characteristics) {
  return function (owner) {
    var typeInstance = $typeRef.c4i(owner.namespace);
    return owner.appendProperty($name, typeInstance, toSet($characteristics));
  };
}
//region block: post-declaration
setMetadataFor(Komposite, 'Komposite', objectMeta);
protoOf(KompositeSemanticAnalyser).analyse = analyse;
setMetadataFor(KompositeSemanticAnalyser, 'KompositeSemanticAnalyser', classMeta, VOID, [SemanticAnalyser]);
protoOf(KompositeSyntaxAnalyser2).configure = configure;
setMetadataFor(KompositeSyntaxAnalyser2, 'KompositeSyntaxAnalyser2', classMeta);
setMetadataFor(TypeRefInfo, 'TypeRefInfo', classMeta);
//endregion
//region block: exports
export {
  Komposite_getInstance as a,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlin.komposite-komposite-processor.mjs.map
